import { Link } from "../../util/router";
import PeopleCardProgressEntry from "./PeopleCardProgressEntry";
import { LinkIcon } from "@heroicons/react/24/outline";

export default function PeopleProgressCard({ teamMembers = [] }) {
  const hasMembers = teamMembers.length > 0;

  return (
    <div className="rounded-lg border-solid border border-green-600">
      <ul className="">
        {hasMembers && (
          <>
            {teamMembers.map((memberUid) => (
              <div key={memberUid}>
                <PeopleCardProgressEntry uid={memberUid} />
              </div>
            ))}
          </>
        )}

        {!hasMembers && (
          <div className="flex p-4 text-center align-center w-full justify-center">
            <div className="flex flex-col items-center">
              <p className="text-md font-semibold leading-6 text-gray-900">
                No team members yet
              </p>
              <Link to="/teams/all">
                <button
                  type="button"
                  className="relative flex flex-col items-center rounded-lg border border-dashed border-green-700 p-4 text-center hover:border-green-500 focus:outline-none text-green-700 hover:text-green-500 hover:bg-green-50"
                >
                  <LinkIcon className="h-12 justify-center" />
                  <span className="mt-2 text-sm font-semibold text-gray-900">Invite Team Members</span>
                </button>
              </Link>
            </div>
          </div>
        )}
      </ul>
    </div>
  );
}
